import { render, staticRenderFns } from "./RespImgShopify.vue?vue&type=template&id=30378718&lang=pug&"
import script from "./RespImgShopify.vue?vue&type=script&lang=js&"
export * from "./RespImgShopify.vue?vue&type=script&lang=js&"
import style0 from "./RespImgShopify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports